const OPEN_STATUSES = ['draft', 'sent', 'viewed'];

function isDefinitiveType(proposalType) {
  return proposalType === 'definitive' || proposalType == null;
}

/**
 * Pick the proposal a measurement work order should open in the configurator.
 *
 * - Unfinished definitive at the head of the chain → continue that draft (`revise`)
 * - Accepted definitive → new version (`create_definitive_from_proforma`, remasure)
 * - Accepted proforma → first definitive (`create_definitive_from_proforma`)
 */
export function pickMeasurementSourceProposal(proposals = []) {
  const list = Array.isArray(proposals) ? proposals : [];
  const relevant = list.filter(
    (p) => p?.proposal_type === 'proforma' || isDefinitiveType(p?.proposal_type)
  );
  const previousIds = new Set(relevant.map((p) => p.previous_version_id).filter(Boolean));
  const isHead = (p) => !previousIds.has(p.id);

  const openDefinitive = relevant.find(
    (p) => isHead(p) && isDefinitiveType(p.proposal_type) && OPEN_STATUSES.includes(p.status)
  );
  if (openDefinitive) {
    return {
      proposal: openDefinitive,
      intent: 'revise',
      isRemeasure: true,
      needsConfirm: false,
    };
  }

  const acceptedDefinitive = relevant.find(
    (p) => isHead(p) && isDefinitiveType(p.proposal_type) && p.status === 'accepted'
  );
  if (acceptedDefinitive) {
    return {
      proposal: acceptedDefinitive,
      intent: 'create_definitive_from_proforma',
      isRemeasure: true,
      needsConfirm: true,
    };
  }

  const acceptedProforma = relevant.find(
    (p) => p.proposal_type === 'proforma' && p.status === 'accepted'
  );
  if (acceptedProforma) {
    return {
      proposal: acceptedProforma,
      intent: 'create_definitive_from_proforma',
      isRemeasure: false,
      needsConfirm: false,
    };
  }

  return null;
}
